import { ArrowRight, FlameIcon } from 'assets/icons';
import GoalRing from './GoalRing';

/**
 * The banner of the period, in the style of « Appels du jour » on the home
 * page: its message, its link, the streak of reviews and the gauge of the
 * goal. The whole banner leads where its link goes.
 */
const PeriodBanner = ({ title, text, link, pill, value, goal }) => (
  <button
    type="button"
    onClick={link?.onClick}
    disabled={!link}
    className="group flex min-h-[146px] w-full items-center gap-4 rounded-2xl bg-blue-50 p-4 text-left transition-colors enabled:hover:bg-[#e3edfd] disabled:cursor-default"
  >
    <span className="flex min-w-0 flex-1 flex-col gap-1">
      <span className="text-lg font-semibold leading-7 text-gray-900">
        {title}
      </span>
      <span className="text-sm leading-5 text-gray-700">{text}</span>
      {link && (
        <span className="flex items-center gap-2.5 pt-0.5 text-sm font-medium text-blue-700 underline-offset-4 group-hover:underline">
          {link.label}
          <span className="flex transition-transform group-hover:translate-x-0.5">
            <ArrowRight wh={20} color="currentColor" />
          </span>
        </span>
      )}
    </span>
    {pill && (
      <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-white px-3 py-1.5 text-xs font-medium leading-4 text-gray-900">
        <FlameIcon wh={14} color="currentColor" />
        {pill}
      </span>
    )}
    <GoalRing value={value} goal={goal} />
  </button>
);

export default PeriodBanner;
